import { useEffect, useState } from "react";
import useWindowSize from "../../../../hooks/useWindowSize";
import { func } from "../../../../utils";
import {
  Card,
  Container,
  HighlightedDate,
  Icon,
  Stroke,
  SubtitleCard,
  TimelineWrapper,
  TitleCard,
} from "./TimelinePathScroll.styled";
import moment from "moment";

const imgPath = `${process.env.REACT_APP_API_HOST}/uploads/timeline/`;

const CirclePath = ({ isActive, isHalf, isPassed }) => {
  const { size } = useWindowSize();

  const isMobileView = (size?.width || 0) <= 768;
  if (isActive) {
    return (
      <img
        src={func.getStaticImg(
          `illustration/${
            isPassed ? "checked-timeline.svg" : "active-circle-timeline.svg"
          }`
        )}
        style={{
          marginLeft: isHalf ? "50%" : 0,
          width: isMobileView ? 16 : 28,
        }}
      />
    );
  } else {
    return (
      <img
        src={func.getStaticImg(
          `illustration/${
            isPassed ? "checked-timeline.svg" : "inactive-circle-timeline.svg"
          }`
        )}
        style={{
          marginLeft: isHalf ? "50%" : 0,
          width: isMobileView ? 16 : "auto",
        }}
      />
    );
  }
};

const TimelinePathScroll = ({ data = [] }) => {
  const [dataActiveByIndex, setDataActiveByIndex] = useState(0);
  const isAllStatusCompleted = data?.filter((val) => val?.status)?.length === 0;
  const { size } = useWindowSize();

  const isMobileView = (size?.width || 0) <= 768;
  useEffect(() => {
    const dataActiveIndex = data?.findIndex((val) => val?.status);
    const element = document.getElementById("container-timeline-path");
    // if want to third one simply  119 * (n)
    if (dataActiveIndex && isMobileView) {
      element.scrollLeft = 220 * dataActiveIndex; //sample if want to scroll into 2nd item
    } else {
      element.scrollLeft = 0;
    }
    setDataActiveByIndex(dataActiveIndex);
  }, [data, dataActiveByIndex]);

  return (
    <Container id="container-timeline-path">
      {data?.map((val, i) => {
        const isActiveDate = val?.status;
        const isPreviousActive = isAllStatusCompleted || i <= dataActiveByIndex;

        const isOnGoingActive =
          isActiveDate || isPreviousActive || isAllStatusCompleted;

        const getDate = (index) => {
          const startShortDate = moment(val?.start_date)?.format("D MMMM");
          const shortDate = moment(val?.start_date)?.format("D MMMM YYYY");

          const endFullDate = moment(val?.end_date)?.format("D MMMM YYYY");

          if (val?.start_date !== val?.end_date) {
            //check if month is the same
            if (moment(val?.start_date)?.isSame(val?.end_date, "month")) {
              return `${moment(val?.start_date)?.format("D")} - ${endFullDate}`;
            }
            return `${startShortDate} - ${endFullDate}`;
          } else {
            return shortDate;
          }
        };

        const handleClick = () => {
          if ((isActiveDate && val?.link) || isAllStatusCompleted) {
            return window.open(val?.link, "_blank");
          } else return false;
        };
        return (
          <div key={i}>
            <TimelineWrapper>
              {!i ? (
                <>
                  <CirclePath
                    isActive={isActiveDate}
                    isPassed={isPreviousActive && !isActiveDate}
                    isHalf
                  />
                  <Stroke isActive={isOnGoingActive && !isActiveDate} />
                </>
              ) : (
                <>
                  <Stroke width={"50%"} isActive={isOnGoingActive} />
                  <CirclePath
                    isActive={isActiveDate}
                    isPassed={isPreviousActive && !isActiveDate}
                  />
                  {data?.length - 1 !== i && (
                    <Stroke
                      width={"50%"}
                      isActive={isOnGoingActive && !isActiveDate}
                    />
                  )}
                </>
              )}
            </TimelineWrapper>
            <HighlightedDate
              isHalf
              isActive={isActiveDate}
              isPassed={isOnGoingActive}
            >
              {getDate(i)}
            </HighlightedDate>
            <Card
              isPreviousActive={isPreviousActive}
              isActive={isActiveDate}
              marginLeft={"16px"}
              marginRight={data?.length - 1 === i ? "24px" : 0}
              onClick={handleClick}
              // cursorPointer={!isPreviousActive && isActiveDate}
            >
              <Icon src={imgPath + val?.icon} isActive={isOnGoingActive} />
              <div>
                <TitleCard
                  isActive={isActiveDate}
                  isOnGoingActive={isOnGoingActive}
                >
                  {val?.title}
                </TitleCard>
                <SubtitleCard>{val?.subtitle}</SubtitleCard>
              </div>

              {/* {data?.length - 1 !== i && ( */}
              <Icon
                style={{ marginLeft: "auto", top: -4, position: "relative" }}
                src={func.getStaticImg(
                  `${
                    isPreviousActive && !isActiveDate
                      ? "illustration/sa-success-circle.svg"
                      : "illustration/sa-chevron-right-blue.svg"
                  }`
                )}
                isActive={isOnGoingActive}
              />
              {/* )} */}
            </Card>
          </div>
        );
      })}
    </Container>
  );
};

export default TimelinePathScroll;
